(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[227],{

/***/ 4550:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dog",
      function () {
        return __webpack_require__(7367);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2116);
/* harmony import */ var components_layout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8019);


const DefaultLayout = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("header", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(components_layout__WEBPACK_IMPORTED_MODULE_1__/* .Navigation */ .W, {
                    success: true,
                    error: false
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("aside", {
                "aria-labelledby": "comp1",
                className: "left",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("p", {
                        id: "comp1",
                        children: "Cryptids of Cornwall:"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("dl", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("dt", {
                                children: "Beast of Bodmin"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("dd", {
                                children: "A large feline inhabiting Bodmin Moor."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("dt", {
                                children: "Morgawr"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("dd", {
                                children: "A sea serpent."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("dt", {
                                children: "Owlman"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("dd", {
                                children: "A giant owl-like creature."
                            })
                        ]
                    })
                ]
            }),
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("aside", {
                "aria-labelledby": "comp2",
                className: "right",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("h2", {
                        id: "comp2",
                        children: "Title for complementary area 2"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("p", {
                        children: "Something which is supposed to be on the right side"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("footer", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(components_layout__WEBPACK_IMPORTED_MODULE_1__/* .Footer */ .$, {})
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DefaultLayout);


/***/ }),

/***/ 7367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "config": function() { return /* binding */ config; },
  "default": function() { return /* binding */ dog; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/preact@10.11.0/node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(2116);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sentry+hub@7.12.1/node_modules/@sentry/hub/esm/exports.js
var esm_exports = __webpack_require__(2916);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.1_ceqegk62aowd7zijfxyuzsexrq/node_modules/next/amp.js
var amp = __webpack_require__(4284);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.1_ceqegk62aowd7zijfxyuzsexrq/node_modules/next/head.js
var head = __webpack_require__(9312);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.1_ceqegk62aowd7zijfxyuzsexrq/node_modules/next/link.js
var next_link = __webpack_require__(5150);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.1_ceqegk62aowd7zijfxyuzsexrq/node_modules/next/router.js
var next_router = __webpack_require__(5852);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-jsx@5.0.7_lyrpg3s5qdiygbgk7rgnrugd7e/node_modules/styled-jsx/style.js
var style = __webpack_require__(1292);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
;// CONCATENATED MODULE: ./src/components/byline.tsx


const Byline = (param)=>/*#__PURE__*/ {
    let { author  } = param;
    return (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                className: "jsx-8110ce82e013c658" + " " + "byline",
                children: [
                    "By ",
                    author
                ]
            }),
            (0,jsx_runtime/* jsx */.tZ)((style_default()), {
                id: "8110ce82e013c658",
                children: ".byline.jsx-8110ce82e013c658{color:green;font-weight:bolder}"
            })
        ]
    });
};
/* harmony default export */ var byline = (Byline);

// EXTERNAL MODULE: ./src/layouts/default.layout.tsx
var default_layout = __webpack_require__(2320);
;// CONCATENATED MODULE: ./src/pages/dog.tsx
/* provided dependency */ var process = __webpack_require__(4922);
/* import { GetStaticProps, GetStaticPropsContext } from 'next' */ 







var __N_SSG = true;
/* eslint-disable import/exports-last, import/group-exports */ /* istanbul ignore next */ const config = {
    amp: "hybrid"
};
const throwError = ()=>{
    /* throw new Error('Sentry Frontend Error') */ /* Sentry.captureException(err); */ (0,esm_exports/* captureMessage */.uT)("Something went wrong with the dog");
};
/* const Dog:NextPage<HomeProps> = (props: HomeProps): JSX.Element => { */ /* const Dog: NextPage = (props: HomeProps): JSX.Element => { */ /* const Dog: NextPage = (props: HomeProps) => { */ /* const Dog: NextPage = () => { */ const Dog = (param)=>{
    let /* props: InferGetStaticPropsType<typeof getStaticProps> */ { host  } = param;
    /* const Dog = (props: HomeProps): JSX.Element => { */ const isAmp = (0,amp.useAmp)();
    const router = (0,next_router.useRouter)();
    const { locale  } = router;
    const imageUrl = "https://picsum.photos/id/237/800/450";
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("main", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("title", {
                        children: "The Dog"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("link", {
                        as: "image",
                        href: imageUrl,
                        rel: "preload"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h1", {
                children: "The Dog (Hybrid AMP Page)"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("h2", {
                children: [
                    "Find out more ",
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("a", {
                        href: host,
                        children: "here"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(byline, {
                author: "Meow Meow Fuzzyface"
            }),
            "The value of platform is: ",
            "VERCEL",
            "The value of customKey is: ",
            process.env.customKey,
            isAmp ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("amp-img", {
                alt: "a cute pups",
                height: "450",
                src: imageUrl,
                width: "800"
            }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("img", {
                alt: "a cute pups",
                height: "450",
                src: imageUrl,
                width: "800"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                children: isAmp ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((link_default()), {
                    href: "/dog",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("a", {
                        children: "View Non-AMP Version"
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("a", {
                    href: locale === undefined ? "/dog/?amp=1" : "/".concat(locale, "/dog?amp=1"),
                    children: [
                        "view ",
                        locale,
                        " amp version"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("button", {
                type: "button",
                onClick: throwError,
                children: "Throw error"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                className: "caption",
                children: "Woooooooooooof"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                children: "The redirect from the non-amp version to the amp version is not working when using LINK but without using LINK I don't get it localized. I think the reason is that link is doing a local/frontend redirect which is not able to load the amp stuff."
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                children: [
                    "Wafer donut candy souffl\xe9",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("a", {
                        href: isAmp ? "/?amp=1" : "/",
                        children: "lemon drops"
                    }),
                    " icing. Marzipan gummi bears pie danish lollipop pudding powder gummi bears sweet. Pie sweet roll sweet roll topping chocolate bar drag\xe9e pudding chocolate cake. Croissant sweet chocolate bar cheesecake candy canes. Tootsie roll icing macaroon bonbon cupcake apple pie candy canes biscuit candy canes. Jujubes jelly liquorice toffee gingerbread. Candy tootsie roll macaroon chocolate bar icing sugar plum pie. Icing gummies chocolate bar chocolate marzipan bonbon cookie chocolate tart. Caramels danish halvah croissant. Cheesecake cookie tootsie roll ice cream. Powder dessert carrot cake muffin tiramisu lemon drops liquorice topping brownie. Souffl\xe9 chocolate cake croissant cupcake jelly."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                children: "Muffin gummies dessert cheesecake candy canes. Candy canes danish cotton candy tart dessert powder bear claw marshmallow. Muffin chocolate marshmallow danish. Chocolate bar biscuit cake tiramisu. Topping sweet brownie jujubes powder marzipan. Croissant wafer bonbon chupa chups cake cake marzipan caramels jujubes. Cupcake cheesecake sweet roll marshmallow lollipop danish jujubes jelly icing. Apple pie chupa chups lollipop jelly-o cheesecake jelly beans cake dessert. Tootsie roll tootsie roll bonbon pastry croissant gummi bears cake cake. Fruitcake sugar plum halvah gingerbread cookie pastry chupa chups wafer lemon drops. Marshmallow liquorice oat cake lollipop. Lemon drops oat cake halvah liquorice danish powder cupcake souffl\xe9. Cake tart topping jelly-o tart sugar plum. Chocolate bar cookie wafer tootsie roll candy cotton candy toffee pie donut."
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                children: "Ice cream lollipop marshmallow tiramisu jujubes croissant. Bear claw lemon drops marzipan candy bonbon cupcake powder. Candy canes cheesecake bear claw pastry cake donut jujubes. Icing tart jelly-o souffl\xe9 bonbon apple pie. Cheesecake pie chupa chups toffee powder. Bonbon lemon drops carrot cake pudding candy halvah cheesecake lollipop cupcake. Pudding marshmallow fruitcake. Gummi bears bonbon chupa chups lemon drops. Wafer dessert gummies gummi bears biscuit donut tiramisu gummi bears brownie. Tootsie roll liquorice bonbon cookie. Sesame snaps chocolate bar cake croissant chupa chups cheesecake gingerbread tiramisu jelly. Cheesecake ice cream muffin lollipop gummies. Sesame snaps jelly beans sweet bear claw tart."
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                children: "Sweet topping chupa chups chocolate cake jelly-o liquorice danish. Pastry jelly beans apple pie dessert pastry lemon drops marzipan gummies. Jelly beans macaroon bear claw cotton candy. Toffee sweet lollipop toffee oat cake. Jelly-o oat cake fruitcake chocolate bar sweet. Lemon drops gummies chocolate cake lollipop bear claw croissant danish icing. Chocolate bar donut brownie chocolate cake lemon drops chocolate bar. Cake fruitcake pudding chocolate apple pie. Brownie tiramisu chocolate macaroon lemon drops wafer souffl\xe9 jujubes icing. Cheesecake tiramisu cake macaroon tart lollipop donut. Gummi bears drag\xe9e pudding bear claw. Muffin cake cupcake candy canes. Souffl\xe9 candy canes biscuit. Macaroon gummies danish."
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                children: "Cupcake cupcake tart. Cotton candy danish candy canes oat cake ice cream candy canes powder wafer. Chocolate sesame snaps oat cake drag\xe9e cheesecake. Sesame snaps marshmallow topping liquorice cookie marshmallow. Liquorice pudding chocolate bar. Cake powder brownie fruitcake. Carrot cake dessert marzipan sugar plum cupcake cheesecake pastry. Apple pie macaroon ice cream fruitcake apple pie cookie. Tootsie roll ice cream oat cake cheesecake donut cheesecake bear claw. Sesame snaps marzipan jelly beans chocolate tootsie roll. Chocolate bar donut drag\xe9e ice cream biscuit. Pie candy canes muffin candy canes ice cream tiramisu."
            })
        ]
    });
};
Dog.Layout = default_layout/* default */.Z;
/* harmony default export */ var dog = (Dog);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [888,774,179], function() { return __webpack_exec__(4550); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);